import { gql, useMutation } from '@apollo/client';
import { GET_QUESTIONNAIRES_BY_ID } from './get-employee-questionnaire-by-id.hook';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';

export const CREATE_EMPLOYEE_QUESTIONNAIRES = gql`
  mutation createEmployeeQuestionnaire($payload: CreateEmployeeQuestionnaireInput!) {
    createEmployeeQuestionnaire(payload: $payload) {
      _id
      questionnaireSettingsId
      companyId
      jobId
      jobLocationId
      status
      applicantId
      employeePersonalInfo {
        firstName
        lastName
        email
      }
    }
  }
`;

export const useCreateEmployeeQuestionnaire = ({ onSuccess }: { onSuccess: () => void }) => {
  const [createEmployeeQuestionnaire, { loading }] = useMutation(CREATE_EMPLOYEE_QUESTIONNAIRES, {
    onCompleted: data => {
      if (data && onSuccess) {
        onSuccess();
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: 'Error',
        description: error?.message || error?.description,
      });
    },
    refetchQueries: [GET_QUESTIONNAIRES_BY_ID],
  });
  return { createEmployeeQuestionnaire, loading };
};
